// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconCheckCircle.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconCheckCircle = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path fillRule="evenodd" clipRule="evenodd" d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7.33908 11.9249L7.41414 12L13.6782 5.73592L12.264 4.3217L7.33908 9.24663L4.41415 6.3217L2.99994 7.73591L7.26402 12L7.33908 11.9249Z" />
  </BaseIcon>
);

export default IconCheckCircle;
